<div class="tt-wrapper">
  <!-- ═══════════ SCROLL AREA (thead sticky inside) ═══════════ -->
  <div class="tt-scroll" #scrollContainer (scroll)="onTableScroll()">
    <!-- ── SKELETON ── -->
    <table class="tt-table" *ngIf="isLoading">
      <thead class="tt-thead sticky top-0 z-10">
        <tr class="tt-head-row">
          <th class="tt-th w-10 bg-white dark:bg-coal-700"></th>
          <th class="tt-th min-w-[300px] bg-white dark:bg-coal-700">
            <span class="tt-col-label">Task Name</span>
          </th>
          <th
            class="tt-th w-[200px] bg-white dark:bg-coal-700 tt-responsive-col text-center"
          >
            <span class="tt-col-label">Weightage</span>
          </th>
          <th
            class="tt-th min-w-[120px] bg-white dark:bg-coal-700 tt-responsive-col text-center"
          >
            <span class="tt-col-label">Due Date</span>
          </th>
          <th
            *ngIf="!hideAssignedTo"
            class="tt-th w-[100px] bg-white dark:bg-coal-700 text-center"
          >
            <span class="tt-col-label">Assigned To</span>
          </th>
          <th
            class="tt-th w-[130px] bg-white dark:bg-coal-700 tt-responsive-col text-center"
          >
            <span class="tt-col-label">Progress</span>
          </th>
          <th class="tt-th w-[130px] bg-white dark:bg-coal-700 text-center">
            <span class="tt-col-label">Status</span>
          </th>
          <th class="tt-th w-[120px] bg-white dark:bg-coal-700 text-center">
            <span class="tt-col-label">Priority</span>
          </th>
          <th class="tt-th w-[100px] bg-white dark:bg-coal-700 text-center">
            <span class="tt-col-label">Risk</span>
          </th>
          <th class="tt-th w-10 bg-white dark:bg-coal-700"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of skeletonRows" class="tt-row">
          <td class="tt-td"><div class="sk-box w-4 h-4 rounded"></div></td>
          <td class="tt-td">
            <div class="flex items-center gap-3">
              <div class="sk-box w-7 h-7 rounded-lg shrink-0"></div>
              <div class="flex-1">
                <div class="sk-box w-24 h-2.5 rounded mb-1.5"></div>
                <div class="sk-box w-40 h-2.5 rounded"></div>
              </div>
            </div>
          </td>
          <td class="tt-td tt-responsive-col text-center">
            <div class="sk-box w-20 h-3 rounded mx-auto"></div>
          </td>
          <td class="tt-td tt-responsive-col">
            <div class="sk-box w-20 h-3 rounded mb-1.5"></div>
            <div class="sk-box w-12 h-3 rounded"></div>
          </td>
          <td *ngIf="!hideAssignedTo" class="tt-td text-center">
            <div class="sk-box w-7 h-7 rounded-full mx-auto"></div>
          </td>
          <td class="tt-td tt-responsive-col">
            <div class="flex items-center gap-2 w-[100px] mx-auto">
              <div class="sk-box h-1.5 rounded-full flex-1"></div>
              <div class="sk-box w-7 h-3 rounded"></div>
            </div>
          </td>
          <td class="tt-td text-center">
            <div class="sk-box w-14 h-5 rounded-full mx-auto"></div>
          </td>
          <td class="tt-td text-center">
            <div class="sk-box w-14 h-5 rounded-full mx-auto"></div>
          </td>
          <td class="tt-td text-center">
            <div class="sk-box w-14 h-5 rounded-full mx-auto"></div>
          </td>
          <td class="tt-td"><div class="sk-box w-4 h-4 rounded"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- ── NEW NO DATA VIEW (active) ── -->
    <div *ngIf="false" class="tt-nd-wrap">
      <!-- Ghost rows -->
      <div class="tt-nd-ghost-rows" aria-hidden="true">
        <div class="tt-nd-ghost-row" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
          <div class="tt-nd-ghost-check"></div>
          <div class="tt-nd-ghost-badge"></div>
          <div class="tt-nd-ghost-line tt-nd-ghost-line--long"></div>
          <div
            class="tt-nd-ghost-line tt-nd-ghost-line--mid"
            style="margin-left: auto"
          ></div>
          <div class="tt-nd-ghost-pill"></div>
          <div class="tt-nd-ghost-pill tt-nd-ghost-pill--sm"></div>
        </div>
      </div>

      <!-- Floating card -->
      <div class="tt-nd-card">
        <div class="tt-nd-card-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect
              x="3"
              y="5"
              width="22"
              height="20"
              rx="4"
              stroke="url(#nd-g)"
              stroke-width="1.8"
              fill="none"
            />
            <rect
              x="10"
              y="2"
              width="8"
              height="5"
              rx="1.8"
              stroke="url(#nd-g)"
              stroke-width="1.6"
              fill="none"
            />
            <path
              d="M9 13h10M9 18h6"
              stroke="url(#nd-g)"
              stroke-width="1.8"
              stroke-linecap="round"
              opacity=".5"
            />
            <circle cx="7" cy="13" r="1.5" fill="url(#nd-g)" opacity=".7" />
            <circle cx="7" cy="18" r="1.5" fill="url(#nd-g)" opacity=".4" />
            <defs>
              <linearGradient
                id="nd-g"
                x1="3"
                y1="2"
                x2="25"
                y2="25"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#3699ff" />
                <stop offset="1" stop-color="#a78bfa" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <p class="tt-nd-card-title">No Tasks Found</p>
        <p class="tt-nd-card-sub">
          No tasks match your current search or filter. Try adjusting your
          criteria.
        </p>
        <div class="tt-nd-card-tags">
          <span class="tt-nd-tag">Status</span>
          <span class="tt-nd-tag">Priority</span>
          <span class="tt-nd-tag">Risk</span>
          <span class="tt-nd-tag">Due Date</span>
        </div>
      </div>
    </div>
    <!-- ── END NEW NO DATA VIEW ── -->

    <!-- ── SIMPLE NO DATA VIEW (active) ── -->
    <div
      *ngIf="!isLoading && formData?.records == null"
      class="flex flex-col items-center justify-center w-full"
      style="min-height: calc(100vh - 280px)"
    >
      <app-no-data-view
        title="No Tasks Found"
        description="There are no tasks matching your current filters or search."
        imagePath="./assets/media/icons/empty-task-small.svg"
        imageHeight="64px"
      >
      </app-no-data-view>
    </div>
    <!-- ── END SIMPLE NO DATA VIEW ── -->

    <!-- ── DATA TABLE ── -->
    <table class="tt-table" *ngIf="!isLoading && formData?.records != null">
      <thead class="tt-thead sticky top-0 z-10">
        <tr class="tt-head-row">
          <th
            class="tt-th w-10 bg-white dark:bg-coal-700"
            *ngIf="taskAssigned == '' && isWriteAccess"
          ></th>
          <th class="tt-th min-w-[300px] bg-white dark:bg-coal-700">
            <div class="flex items-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('taskId')"
                >Task Name</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['taskId'] === 'asc'"
                  (click)="onSort('taskId', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['taskId'] === 'desc'"
                  (click)="onSort('taskId', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th
            class="tt-th w-[200px] bg-white dark:bg-coal-700 tt-responsive-col !text-center"
          >
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('weightage')"
                >Weightage</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['weightage'] === 'asc'"
                  (click)="onSort('weightage', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['weightage'] === 'desc'"
                  (click)="
                    onSort('weightage', 'desc'); $event.stopPropagation()
                  "
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th
            class="tt-th min-w-[130px] bg-white dark:bg-coal-700 !text-center tt-responsive-col"
          >
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('dueDate')"
                >Due Date</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['dueDate'] === 'asc'"
                  (click)="onSort('dueDate', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['dueDate'] === 'desc'"
                  (click)="onSort('dueDate', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <!-- <th class="tt-th w-[100px] bg-white dark:bg-coal-700 !text-center">
            <span class="tt-col-label"></span>
          </th> -->
          <th
            *ngIf="!hideAssignedTo"
            class="tt-th w-[100px] bg-white dark:bg-coal-700 !text-center"
          >
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('assigned')"
                >Assigned To</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['assigned'] === 'asc'"
                  (click)="onSort('assigned', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['assigned'] === 'desc'"
                  (click)="onSort('assigned', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th
            class="tt-th w-[130px] bg-white dark:bg-coal-700 tt-responsive-col !text-center"
          >
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('progress')"
                >Progress</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['progress'] === 'asc'"
                  (click)="onSort('progress', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['progress'] === 'desc'"
                  (click)="onSort('progress', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th class="tt-th w-[130px] bg-white dark:bg-coal-700 !text-center">
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('status')"
                >Status</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['status'] === 'asc'"
                  (click)="onSort('status', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['status'] === 'desc'"
                  (click)="onSort('status', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th class="tt-th w-[120px] bg-white dark:bg-coal-700 !text-center">
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('priority')"
                >Priority</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['priority'] === 'asc'"
                  (click)="onSort('priority', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['priority'] === 'desc'"
                  (click)="onSort('priority', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th class="tt-th w-[100px] bg-white dark:bg-coal-700 !text-center">
            <div class="flex items-center justify-center gap-2">
              <span
                class="tt-col-label cursor-pointer"
                (click)="toggleSort('risk')"
                >Risk</span
              >
              <div class="flex flex-col gap-0.5">
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['risk'] === 'asc'"
                  (click)="onSort('risk', 'asc'); $event.stopPropagation()"
                >
                  <path d="M1 4.5l3.5-4L8 4.5" />
                </svg>
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  stroke="#5e6d8a"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  class="cursor-pointer"
                  [class.active]="currentSort['risk'] === 'desc'"
                  (click)="onSort('risk', 'desc'); $event.stopPropagation()"
                >
                  <path d="M1 .5l3.5 4L8 .5" />
                </svg>
              </div>
            </div>
          </th>
          <th class="tt-th w-10 bg-white dark:bg-coal-700">
            <div class="flex items-center gap-2">
              <span class="tt-col-label cursor-pointer">Action</span>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let item of formData?.records; let i = index">
          <!-- ── Main row ── -->
          <tr (click)="onRowClick($event, item)" class="tt-row group">
            <!-- Checkbox -->
            <td
              class="tt-td w-10"
              (click)="$event.stopPropagation()"
              *ngIf="taskAssigned == '' && isWriteAccess"
            >
              <input
                type="checkbox"
                class="checkbox cursor-pointer"
                [checked]="isSelected(item)"
                (click)="onRowSelect(item, $event)"
              />
            </td>

            <!-- Task Name -->
            <td class="tt-td min-w-[300px]" style="padding-left: 8px">
              <div class="flex items-center gap-2">
                <!-- Chevron -->
                <button
                  class="rt-chevron-btn shrink-0"
                  (click)="toggleExpand(item._id, $event)"
                  [title]="isExpanded(item._id) ? 'Collapse' : 'Expand'"
                >
                  <svg
                    class="rt-chevron"
                    [class.open]="isExpanded(item._id)"
                    width="14"
                    height="14"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M1 1l4 4 4-4"
                      stroke="currentColor"
                      stroke-width="1.7"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <!-- Domain badge -->
                <div
                  class="tt-domain-icon shrink-0"
                  [ngStyle]="getDomainBg(item.taskId)"
                >
                  {{ getDomainInitials(item.taskId) }}
                </div>
                <!-- ID + Name -->
                <div class="min-w-0">
                  <div
                    class="tt-task-id-btn"
                    (click)="toggleExpand(item._id, $event)"
                    [attr.title]="item.taskId"
                  >
                    {{ item.taskId }}
                  </div>
                  <div
                    class="tt-task-name line-clamp-1"
                    [attr.title]="item.control"
                  >
                    {{ item.control }}
                  </div>
                </div>
              </div>
            </td>

            <!-- Weightage-->
            <td class="tt-td w-[200px] tt-responsive-col text-center">
              <div
                class="flex justify-center items-center gap-2 text-gray-900 dark:text-white font-medium text-xs"
              >
                <span title="Actionables">{{ item.weightage || 0 }}</span>
              </div>
            </td>

            <!-- Due Date -->
            <td class="tt-td min-w-[130px] tt-responsive-col">
              <ng-container *ngIf="item.dueDate; else noDate">
                <div class="tt-date-line">
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 16 16"
                    fill="none"
                    class="shrink-0 opacity-50"
                  >
                    <rect
                      x="1"
                      y="3"
                      width="14"
                      height="12"
                      rx="2"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <path
                      d="M5 1v4M11 1v4M1 7h14"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                  {{ formatDueDate(item.dueDate) }}
                </div>
                <div
                  class="tt-due-relative"
                  [ngClass]="getDueDateRelative(item.dueDate).colorClass"
                >
                  {{ getDueDateRelative(item.dueDate).text }}
                </div>
              </ng-container>
              <ng-template #noDate>
                <span class="tt-empty">—</span>
              </ng-template>
            </td>

            <!-- Assigned To -->
            <td
              *ngIf="!hideAssignedTo"
              class="tt-td w-[100px] text-center"
              (click)="$event.stopPropagation()"
            >
              <div class="flex justify-center">
                <div
                  *ngIf="item.assignee?.name || item.assigned"
                  class="tt-avatar group relative"
                  [ngClass]="getBgColor(item.assignee?.name || item.assigned)"
                  [class.cursor-pointer]="isWriteAccess"
                  (click)="isWriteAccess && assignUsers(item, $event)"
                  [title]="item.assignee?.name || item.assigned"
                >
                  <img
                    [src]="getAssigneePhotoUrl(item)"
                    alt="Assignee Photo"
                    class="w-full h-full rounded-full object-cover"
                    (error)="handleImageError($event)"
                  />
                  <div class="tt-avatar-overlay" *ngIf="isWriteAccess">
                    <i
                      class="ki-outline ki-notepad-edit text-white text-[10px]"
                    ></i>
                  </div>
                </div>
                <div
                  *ngIf="!item.assignee?.name && !item.assigned"
                  class="tt-avatar-empty"
                  [class.cursor-pointer]="isWriteAccess"
                  (click)="isWriteAccess && assignUsers(item, $event)"
                  [title]="isWriteAccess ? 'Assign owner' : ''"
                >
                  <img
                    src="./assets/media/icons/user-add.svg"
                    class="w-3.5 h-3.5 opacity-40"
                  />
                </div>
              </div>
            </td>

            <!-- Progress -->
            <td class="tt-td w-[130px] tt-responsive-col">
              <div class="flex items-center gap-2 w-[110px] mx-auto">
                <div class="tt-progress-track flex-1">
                  <div
                    class="tt-progress-fill"
                    [style.width.%]="getProgress(item)"
                    [style.background]="getProgressColor(getProgress(item))"
                  ></div>
                </div>
                <span
                  class="tt-pct"
                  [style.color]="getProgressColor(getProgress(item))"
                >
                  {{ getProgress(item) }}%
                </span>
              </div>
            </td>

            <!-- Status -->
            <td class="tt-td w-[130px] text-center">
              <span
                class="custom-badge badge badge-sm badge-outline rounded-full text-nowrap"
                [ngClass]="getBadgeClass('status', item.status)"
              >
                {{ item.status }}
              </span>
            </td>

            <!-- Priority -->
            <td class="tt-td w-[120px] text-center">
              <span
                class="custom-badge badge badge-sm badge-outline rounded-full text-nowrap"
                [ngClass]="
                  getBadgeClass('priority', getPriority(item.priority))
                "
              >
                {{ getPriority(item.priority) }}
              </span>
            </td>

            <!-- Risk -->
            <td class="tt-td w-[100px] text-center">
              <span
                class="custom-badge badge badge-sm badge-outline rounded-full text-nowrap"
                [ngClass]="[
                  getBadgeClass('risk', item.risk),
                  'text-' + (item.risk || 'low' | lowercase),
                ]"
              >
                {{ item.risk || "Low" }}
              </span>
            </td>

            <!-- Row menu -->
            <td class="tt-td w-10" (click)="$event.stopPropagation()">
              <div class="relative w-fit mx-auto">
                <button
                  class="tt-menu-btn"
                  (click)="toggleMenu(item._id, $event)"
                >
                  <span></span><span></span><span></span>
                </button>
                <div
                  *ngIf="openMenuId === item._id"
                  class="tt-dropdown"
                  [ngClass]="{
                    'tt-dropdown-up': shouldOpenAbove(item._id),
                  }"
                >
                  <button
                    class="tt-dropdown-item"
                    (click)="onRowClick($event, item)"
                  >
                    View
                  </button>
                  <button
                    *ngIf="taskAssigned == '' && isWriteAccess"
                    class="tt-dropdown-item"
                    (click)="assignUsers(item, $event)"
                  >
                    Assign
                  </button>
                </div>
              </div>
            </td>
          </tr>

          <!-- ── Expand row ── -->
          <tr *ngIf="isExpanded(item._id)" class="tt-expand-row">
            <td [attr.colspan]="colspanCount" class="tt-expand-td">
              <div class="tt-expand-content">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full">
                  <div class="flex flex-col">
                    <span class="tt-expand-label">Description</span>
                    <p class="tt-expand-text">
                      {{ item.description || "No description available." }}
                    </p>
                    <div
                      *ngIf="
                        item.parentTags?.length ||
                        item.tags?.length ||
                        item.technology?.length
                      "
                      class="tt-expand-meta"
                    >
                      <span
                        *ngFor="let tag of getUniqueTags(item)"
                        class="badge badge-sm badge-outline rounded-full badge-secondary cursor-pointer hover:bg-secondary hover:text-white transition-colors"
                        (click)="onTagClick(tag, $event)"
                      >
                        {{ tag }}
                      </span>
                    </div>
                    <!-- Progress (shown only when column is hidden) -->
                    <div
                      class="flex flex-col mt-4 tt-responsive-info w-full max-w-[200px]"
                    >
                      <span class="tt-expand-label">Progress</span>
                      <div class="flex items-center gap-2 mt-1">
                        <div class="tt-progress-track flex-1">
                          <div
                            class="tt-progress-fill"
                            [style.width.%]="getProgress(item)"
                            [style.background]="
                              getProgressColor(getProgress(item))
                            "
                          ></div>
                        </div>
                        <span
                          class="tt-pct"
                          [style.color]="getProgressColor(getProgress(item))"
                        >
                          {{ getProgress(item) }}%
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-5">
                    <div class="flex gap-10 tt-responsive-info">
                      <div class="flex flex-col">
                        <span class="tt-expand-label">Due Date</span>
                        <ng-container *ngIf="item.dueDate; else noDateExp">
                          <div class="tt-date-line">
                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 16 16"
                              fill="none"
                              class="shrink-0 opacity-50"
                            >
                              <rect
                                x="1"
                                y="3"
                                width="14"
                                height="12"
                                rx="2"
                                stroke="currentColor"
                                stroke-width="1.5"
                              />
                              <path
                                d="M5 1v4M11 1v4M1 7h14"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                            {{ formatDueDate(item.dueDate) }}
                          </div>
                          <div
                            class="tt-due-relative"
                            [ngClass]="
                              getDueDateRelative(item.dueDate).colorClass
                            "
                          >
                            {{ getDueDateRelative(item.dueDate).text }}
                          </div>
                        </ng-container>
                        <ng-template #noDateExp
                          ><span class="tt-empty">—</span></ng-template
                        >
                      </div>
                      <div class="flex flex-col">
                        <span class="tt-expand-label">Weightage</span>
                        <div
                          class="mt-1 flex items-center gap-2 text-gray-900 dark:text-white font-medium text-xs"
                        >
                          <span title="Actionables">{{
                            item.weightage || 0
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex flex-col"
                      *ngIf="item.mappedStandards?.length"
                    >
                      <span class="tt-expand-label">Mapped Standards</span>
                      <div class="flex flex-wrap gap-3.5 mt-2">
                        <ng-container
                          *ngFor="
                            let std of item.mappedStandards | slice: 0 : 5;
                            let sIndex = index
                          "
                        >
                          <div
                            #tagWrapper
                            class="relative inline-flex"
                            style="overflow: visible"
                          >
                            <!-- Tag chip -->
                            <span
                              class="cv-tag"
                              (click)="navigateToCompliance(item, $event)"
                            >
                              {{ $any(std).standardName }}
                            </span>

                            <!-- Sub-count bubble + tooltip trigger -->
                            <div
                              class="absolute -top-1.5 -right-1.5"
                              style="pointer-events: auto"
                            >
                              <span
                                *ngIf="$any(std).subStandardCount > 0"
                                class="cv-sub-count"
                                (click)="navigateToCompliance(item, $event)"
                              >
                                {{ $any(std).subStandardCount }}
                              </span>

                              <!-- Tooltip -->
                              <!-- <div
                                *ngIf="tooltipMap[item._id + '-' + sIndex]"
                                [id]="'tooltip-' + item._id + '-' + sIndex"
                                class="fixed cv-tooltip-container text-left"
                                [ngStyle]="{
                                  top: tooltipPosition?.top + 'px',
                                  left: tooltipPosition?.left + 'px',
                                }"
                                [style.visibility]="
                                  tooltipPosition ? 'visible' : 'hidden'
                                "
                              >
                                <div
                                  *ngFor="let sub of $any(std).subStandards"
                                  class="cv-tooltip-group"
                                >
                                  <div class="cv-tooltip-title">
                                    {{ sub.name || sub.framework }}
                                  </div>
                                  <ul
                                    class="control-list"
                                    *ngIf="
                                      sub.controls && sub.controls.length > 0
                                    "
                                  >
                                    <li
                                      *ngFor="let control of sub.controls"
                                      class="cv-tooltip-item"
                                    >
                                      {{ control }}
                                    </li>
                                  </ul>
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </ng-container>
                        <span
                          *ngIf="item.mappedStandards.length > 5"
                          (click)="navigateToCompliance(item, $event)"
                          class="custom-badge badge badge-sm badge-light rounded-full text-nowrap font-semibold self-center cursor-pointer"
                        >
                          +{{ item.mappedStandards.length - 5 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <!-- /tt-scroll -->

  <!-- ═══════════ FOOTER — sticky bottom ═══════════ -->
  <div class="tt-footer rounded-b-xl" *ngIf="formData?.records != null">
    <div class="tt-page-size">
      <select
        (change)="changePageSize($event)"
        class="tt-page-size-select dark:bg-coal-700 dark:text-gray-200"
      >
        <option
          class="dark:bg-coal-700 dark:text-gray-200"
          *ngFor="let s of [10, 20, 50, 100]"
          [value]="s"
          [selected]="s === pageSize"
        >
          {{ s }} / page
        </option>
      </select>
      <svg class="tt-select-chevron" width="10" height="6" viewBox="0 0 10 6">
        <path
          d="M1 1l4 4 4-4"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <span
      *ngIf="
        formData?.totalCount !== undefined && formData?.totalCount !== null
      "
      class="text-xs text-gray-600 dark:text-gray-400 font-medium me-auto"
    >
      Total {{ formData?.totalCount ?? 0 }} records
    </span>
    <div class="tt-pagination" *ngIf="totalPages > 1; else emptyPaginationSlot">
      <button
        class="tt-page-btn tt-page-nav"
        [disabled]="currentPage === 1"
        (click)="goToPage(currentPage - 1)"
      >
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
          <path
            d="M6 1L1 6l5 5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <ng-container *ngFor="let p of pageNumbers">
        <button
          *ngIf="p !== '...'"
          class="tt-page-btn"
          [class.active]="p === currentPage"
          (click)="goToPage(p)"
        >
          {{ p }}
        </button>
        <span *ngIf="p === '...'" class="tt-page-dots">…</span>
      </ng-container>
      <button
        class="tt-page-btn tt-page-nav"
        [disabled]="currentPage === totalPages"
        (click)="goToPage(currentPage + 1)"
      >
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
          <path
            d="M1 1l5 5-5 5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <ng-template #emptyPaginationSlot>
      <div class="w-[85px] hidden sm:block"></div>
    </ng-template>
  </div>
</div>

<!-- Assign Modal -->
<div class="modal" data-modal="true" id="assign_modal">
  <div class="modal-content bg-white dark:bg-coal-500">
    <div class="modal-header pr-2.5">
      <span class="text-base font-semibold card-title">{{ modalTitle }}</span>
    </div>
    <div class="modal-body grid gap-5 px-0" *ngIf="activeModalContext">
      <app-modal-renderer
        *ngIf="activeModalContext"
        #modalRendererRef
        [nodeId]="activeModalContext.nodeId"
        (header)="setModalTitle($event)"
        (closeModal)="closeModal()"
        [taskId]="activeModalContext.taskId"
        (formSaved)="onModalFormSaved($event)"
        [activeModalContext]="activeModalContext"
      >
      </app-modal-renderer>
    </div>
  </div>
</div>
